/**
 * CreateAccountModal-Specific Styles
 *
 * These styles are unique to the CreateAccount modal (Terms of Service, Privacy Policy).
 * Common form styles are imported from AuthModal.form.style.js
 *
 * Usage:
 * import * as FormStyled from './AuthModal.form.style';  // Shared styles
 * import * as Styled from './CreateAccountModal.style';  // Modal-specific styles
 */

import Link from '@zenbusiness/zui/Link';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

// Re-export all shared form styles for convenience
export * from './AuthModal.form.style';

// Alias for backward compatibility
export { SecondaryButton as CancelButton } from './AuthModal.form.style';

/**
 * TermsText
 * Legal disclaimer text
 * Required by GDPR/CCPA for account creation
 */
export const TermsText = superstyled({
  name: 'CreateAccountModal',
  slot: 'TermsText',
  tag: Text,
  styles: () => ({
    variant: 'caption'
  })
});

/**
 * TermsLink
 * Links to Terms of Use and Privacy Policy
 * Opens in new tab
 */
export const TermsLink = superstyled({
  name: 'CreateAccountModal',
  slot: 'TermsLink',
  tag: Link,
  styles: ({ theme }) => ({
    color: theme.palette.info.main,
    component: 'a',
    target: '_blank',
    rel: 'noopener noreferrer',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  })
});
